<template>
	<SubBarGlobal :currentCrumb="currentCrumb">
		<div class="dF aC" style="gap: 30px" v-if="$route.path === '/'">
			<a-button v-if="showRefresh" icon="sync" @click="refresh" size="large" :loading="refreshBroadcast"
				:disabled="refreshBroadcast">
				Refresh
			</a-button>
			<a-input placeholder="Search here..." v-model="search" size="large" allowClear>
				<a-icon slot="prefix" type="search" />
			</a-input>
			<a-tooltip v-if="!activePhoneNumbers?.length" overlayClassName="change-tooltip-color">
				<template slot="title">
					<span>
						Please first buy a phone number from <span @click="gotoSetting" class="link">here</span>
					</span>
				</template>
				<a-button type="primary" icon="plus" @click="() => { }" :disabled="true">
					CREATE BROADCAST
				</a-button>
			</a-tooltip>
			<a-button v-else type="primary" icon="plus" @click="newBroadcast">
				CREATE BROADCAST
			</a-button>
		</div>
	</SubBarGlobal>
</template>

<script>
import SubBarGlobal from 'bh-mod/components/layout/SubBarGlobal'

export default {
	components: { SubBarGlobal },
	computed: {
		pageButtons() {
			return this.$store.state.pageButtons
		},
		instance() {
			return this.$store.state.instance
		},
		activePhoneNumbers() {
			return this.$store.state.appData.activePhoneNumbers
		},
		selectedTab() {
			return this.$store.state.appData.selectedTab;
		},
		currentCrumb() {
			const selectedTab = this.selectedTab;
			return this.$route.meta.crumbName ? false : selectedTab.charAt(0).toUpperCase() + selectedTab.slice(1);
		},
		search: {
			get() {
				return this.$store.state.appData.searchFilter;
			},
			set(value) {
				this.$store.commit('UPDATE_SEARCH', value);
			},
		},
		showRefresh() {
			return ["Pending", "Processing"].includes(this.selectedTab);
		},
		refreshBroadcast() {
			return this.$store.state.appData.refreshBroadcast;
		}
	},
	methods: {
		newBroadcast() {
			if (this.activePhoneNumbers?.length > 0) {
				this.$router.push("/new");
			} else {
				this.$message.warning(`You have no active phone numbers. Please rent a new phone number from settings section.`)
			}
		},
		gotoSetting() {
			this.$router.push("/settings?tab=buyNumbers");
		},
		refresh() {
			if (this.refreshBroadcast) return;
			this.$store.commit('REFRESH_BROADCASTS', true);
		}
	},
}
</script>
